import { importProvidersFrom } from '@angular/core';
import { NgxsModule } from '@ngxs/store';
import { securityScorecardStates } from '@pages/executive-reports/components/executive-reports-tabs/security-scorecard-report/store';
import { AppRoute } from '@core/route-data/models/app-routes';

export const executiveReportsRoutes: AppRoute[] = [
  {
    path: '',
    redirectTo: 'security-scorecard',
    pathMatch: 'full',
    data: { prefetchTarget: 'security-scorecard' },
  },
  {
    path: 'security-scorecard',
    loadComponent: () =>
      import('@pages/executive-reports/components/executive-reports-tabs/security-scorecard-report/components/security-scorecard/security-scorecard.component').then(
        modules => modules.SecurityScorecardComponent
      ),
    providers: [importProvidersFrom(NgxsModule.forFeature([...securityScorecardStates]))],
  },
  // {
  //   path: 'service-delivery',
  //   loadComponent: () =>
  //     import(
  //       '@pages/executive-reports/components/executive-reports-tabs/service-delivery-report/components/service-delivery-page/service-delivery-page.component'
  //     ).then(modules => modules.ServiceDeliveryPageComponent),
  //   providers: [importProvidersFrom(NgxsModule.forFeature([...serviceDeliveryStates]))],
  // },
  // {
  //   path: 'security',
  //   providers: [importProvidersFrom(NgxsModule.forFeature([...securityStates]))],
  //   loadComponent: () =>
  //     import('@pages/executive-reports/components/executive-reports-tabs/security/components/security-page/security-page.component').then(
  //       modules => modules.SecurityPageComponent
  //     ),
  // },
];
